const GENERIC_VALIDATION_MESSAGE = 'Required field';
const EMAIL_VALIDATION_MESSAGE = 'Please enter a valid email address';

const FORM_SCHEMA = {
  type: 'object',
  properties: {
    firstname: {
      fieldId: 'firstname',
      label: 'First name',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: true,
      section: 0,
      group: 'name'
    },
    lastname: {
      fieldId: 'lastname',
      label: 'Last name',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: true,
      section: 0,
      group: 'name'
    },
    email: {
      fieldId: 'email',
      label: 'Email address',
      showInForm: true,
      formFieldType: 'email',
      placeholder: '',
      type: 'string',
      pattern: '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$',
      errorMessage: EMAIL_VALIDATION_MESSAGE,
      isRequired: true,
      section: 0
    },
    company: {
      fieldId: 'company',
      label: 'Company',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: GENERIC_VALIDATION_MESSAGE,
      isRequired: true,
      section: 0
    }
  },
  required: ['firstname', 'lastname', 'email', 'company']
};

export { FORM_SCHEMA, GENERIC_VALIDATION_MESSAGE, EMAIL_VALIDATION_MESSAGE };
